import axios from "axios";
import router from '../../router/index'
import {serialize} from "object-to-formdata";
import i18n from '../../i18n'

const user = JSON.parse(localStorage.getItem('user'));
export const state = user
    ? { status: { loggeduser: true }, user }
    : { status: {}, user: null };

function fetchProfile(accessToken) {
    return axios.get(`${process.env.VUE_APP_API_BASE_URL}/jala/profile`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        params: {
            with: 'role,investor_user.role,farm_users',
            appends: 'avatar_url'
        }
    })
}

function fetchTradeProfile(accessToken) {
    return axios.get(`${process.env.VUE_APP_API_BASE_URL}/user`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
    })
}

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    loginPassword({ dispatch, commit }, { username, password }) {
        commit('loginRequest', {});
        const formData = new URLSearchParams([
            ['grant_type', 'password'],
            ['client_id', process.env.VUE_APP_OAUTH2_CLIENT_ID],
            ['client_secret', process.env.VUE_APP_OAUTH2_CLIENT_SECRET],
            ['username', username],
            ['password', password],
            ['scope', '*'],
        ]);
        return axios.post(`${process.env.VUE_APP_OAUTH2_BASE_URL}/token`, formData)
            .then((response) => {
                const { data: { access_token } } = response;
                dispatch('login', { accessToken: access_token });
                return response;
            })
    },
    loginCode({ dispatch, commit }, { code }) {
        commit('loginRequest', {});
        const formData = new URLSearchParams([
            ['grant_type', 'authorization_code'],
            ['client_id', process.env.VUE_APP_OAUTH2_CLIENT_ID],
            ['client_secret', process.env.VUE_APP_OAUTH2_CLIENT_SECRET],
            ['redirect_uri', `${window.location.origin}/login`],
            ['code', code],
        ]);
        return axios.post(`${process.env.VUE_APP_OAUTH2_BASE_URL}/token`, formData)
            .then((response) => {
                const { data: { access_token } } = response;
                dispatch('login', { accessToken: access_token });
                return response;
            })
    },
    login({ dispatch, commit }, { accessToken }) {
        commit('loginRequest', { token: accessToken });
        fetchProfile(accessToken)
        .then(({ data: { data } }) => {
            const user = { ...data, token: accessToken };
            if(user.investor_user || user.farm_users.length){
                return fetchTradeProfile(accessToken).then((tradeData) => {
                    const tradeUser = tradeData.data;
                    window.console.log('tradeUser', tradeUser);
                    if (Boolean(tradeUser.is_active) === false) {
                        commit('loginFailure');
                        dispatch('notification/error', i18n.t('Your account has been deactivated. Please contact an administrator.'), { root: true });
                        return;
                    }
                    user.trade_user = tradeUser;
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('user', JSON.stringify(user));
                    commit('loginSuccess', user);
                    router.push('/');
                });
            } else {
                commit('loginFailure', i18n.t('The user credentials were incorrect.'));
                dispatch('notification/error', i18n.t('The user credentials were incorrect.'), { root: true });
            }
        }, (error) => {
            if (error.response && 400 <= error.response.status && error.response.status < 500) {
                commit('loginFailure', i18n.t('The user credentials were incorrect.'));
                dispatch('notification/error', i18n.t('The user credentials were incorrect.'), { root: true });
            } else {
                commit('loginFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        })
    },
    // Logout the user
    logout({ commit }) {
        localStorage.removeItem('user');
        commit('logout');
    },
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    register({ dispatch, commit }, model) {
        const { family_card_scan, ...modelData } = model;
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/register`, { ...modelData })
            .then((response) => {
                if (!family_card_scan) return response;
                const { data: { meta: { access_token } } } = response;
                return axios.post(
                    `${process.env.VUE_APP_API_BASE_URL}/profile`,
                    serialize({ _method: 'PUT', family_card_scan }, { indices: true, booleansAsIntegers: true }),
                    {headers: {'Authorization': `Bearer ${access_token}`}}
                ).catch(() => response).then(() => response);
            })
            .then((response) => {
                const { data: { meta: { access_token } } } = response;
                dispatch('login', { accessToken: access_token });
                return response;
            })
    },

    // Validates the current user's token and refreshes it
    // with new data from the API.
    // eslint-disable-next-line no-unused-vars
    validate({ commit, state }) {
        if (!state.user) return Promise.resolve(null)
        const accessToken = state.user.token;
        return fetchTradeProfile(accessToken)
        .then((data) => {
            const tradeUser = data.data;
            if (Boolean(tradeUser.is_active) === false) {
                commit('logout');
                localStorage.removeItem('user');
                router.push('/deactivated');
                return null;
            }
            const user = state.user;
            user.trade_user = tradeUser;
            localStorage.setItem('user', JSON.stringify(user));
            commit('loginSuccess', user)
            return true
        }, (error) => {
            commit('loginFailure', error);
            return null;
        })
    }
}

export const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
};
